import { omit } from "lodash"

const helper = {
  // 拼接参数至url
  queryString (url, query) {
    let str = []
    for (let key in query) {
      query[key] && str.push(key + '=' + query[key])
    }
    let paramStr = str.join('&')
    return paramStr ? `${url}?${paramStr}` : url
  },
  // 获取url参数， 返回对象 ex: { inviteID: 24 }
  getUrlParams() {
    let params = {}
    let url = decodeURIComponent(decodeURIComponent(window.location.href))
    // 使用 URL API 代替字符串分割
    try {
      const urlObj = new URL(url)
      for (const [key, value] of urlObj.searchParams.entries()) {
        params[key] = value
      }
    } catch (e) {
      // 兼容非常规URL的降级处理
      const queryString =
        url.indexOf('?') > -1 ? url.split('?').slice(1).join('?') : ''
      queryString.split('&').forEach((param) => {
        const eqIndex = param.indexOf('=')
        if (eqIndex >= 0) {
          params[param.slice(0, eqIndex)] = param.slice(eqIndex + 1)
        }
      })
    }
    return params
  },
  // 获取微信分享的链接参数
  getShareUrlParams() {
    let params = {}
    let url = window.location.href 
    let i = url.lastIndexOf('?')
    i++
    let paramsStr = url.slice(i)
    let paramsItems = paramsStr.split("&")
    for(let paramsItem of paramsItems) {
      let paramsKey = paramsItem.split("=")[0]
      let paramsValue = paramsItem.split("=")[1]
      params[paramsKey] = paramsValue
    }
    return params
  },
  // 会员俱乐部权益页删除privilegeID参数
  removePrivilegeParams(path, params) {
    if (path === '/memberClub/privilege') return omit(params, ['privilegeID'])
    return params
  }
}
export default helper
